import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import appLib from "../../../libs/appLib.mjs";
import {Button, ButtonGroup, Form, Input} from "reactstrap";
import TextLabel from "../../../controls/TextLabel.mjs";
import CloseIcon from "../../../media/assets/CloseIcon.mjs";
import CheckIcon from "../../../media/assets/CheckIcon.mjs";

const prefix = "UserIndex";

const UserVerifyOtp = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: '',
			lang: Glob.getLanguage()
		}
		this.setOtp = this.setOtp.bind(this);
		this.verifyOtp = this.verifyOtp.bind(this);
	}
	setOtp(x = '') {
		x = x.replace(/[^0-9]+/g,'');
		this.setState({value: x, valid: x.length > 4 });
	}
	verifyOtp() {
		this.setState({ sending: true }, async () => {
			let u;
			try {
				u = await appLib.api('auth/verify-otp', { email: Glob.getStatus('emailToBeVerified'), otp: this.state.value });
			} catch (e) {
				u = { error: e.message };
			}
			if ( u?.error ) {
				this.setState({ error: u.error, sending: false });
			} else if ( u?.id && u?.session) {
				appLib.currentUser(u);
				Glob.setStatus('emailToBeVerified');
				Glob.trigger('otp_sent' );
			} else {
				this.setState({ sending: false });
			}
		});
	}
	render() {
		return (
			<Form
				className={prefix+'-verify-otp'}
				autoComplete="off"
				onSubmit={ e =>{
					e.preventDefault();
					if ( ! this.state.valid || this.state.sending ) return;
					this.verifyOtp();
				}}
			>
				{ this.state.lang === 'it' ? (
					<div lang={"it"}>
						Una password usa&amp;getta (OTP, One Time Password) è stata inviata
						a <strong>{ Glob.getStatus('emailToBeVerified') }</strong><br />
						<strong>Verifica anche nello spam</strong>.
					</div>
				) : (
					<div lang={"en"}>
						An OTP (One Time Password) was sent to mailbox <strong>{ Glob.getStatus('emailToBeVerified') }</strong><br />
						<strong>Check for unsolicited emails as well</strong>.
					</div>
				)}
				<Input
					type={"number"}
					placeholder={"OTP"}
					autoFocus={true}
					value={ this.state.value }
					onChange={ e => this.setOtp(String(e.target.value)) }
				/>
				<ButtonGroup
					className="btn-icon"
				>
					<Button
						color="warning"
						type={"reset"}
						onClick={ ()=>{
							Glob.setStatus('emailToBeVerified');
							Glob.trigger('otp_sent' );
						}}
					>
						<i>
							<CloseIcon />
						</i>
						<b>
							<TextLabel value={"Cancel"}  />
						</b>
					</Button>
					<Button
						color={"primary"}
						type="submit"
						disabled={ ! this.state.valid || this.state.sending }
					>
						<b>
							<TextLabel value={"Verify email"} />
						</b>
						<i>
							<CheckIcon />
						</i>
					</Button>
				</ButtonGroup>
				{ this.state.error && <div className="error">{ this.state.error }</div> }
			</Form>
		)
	}
}

export default UserVerifyOtp;